import { ModalProvider } from '@bitstopco/bitstop-theme';

import type { Modals } from '@bitstopco/bitstop-theme';

import AffiliateAddMachines from './modules/affiliates/AddMachines';
import AffiliateAddUser from './modules/affiliates/AddUser';
import AffiliateAddUserV2 from './modules/affiliates/AddUserV2';
import CreateAffiliate from './modules/affiliates/CreateAffiliate';
import CreateAffiliateV2 from './modules/affiliates/CreateAffiliateV2';
import BatchDetails from './modules/batching/BatchDetails';
import BatchingSettings from './modules/batching/BatchingSettings';
import ActivateVendor from './modules/blockchainAnalytics/ActivateVendor';
import ConnectVendor from './modules/blockchainAnalytics/ConnectVendor';
import EditVendor from './modules/blockchainAnalytics/EditVendor';
import CaseCloseModal from './modules/cases/CaseCloseModal';
import CaseCustomNote from './modules/cases/CaseCustomNote';
import CaseNoteUploadAttachment from './modules/cases/CaseNoteUploadAttachment';
import CaseRestartCommand from './modules/cases/CaseRestartCommand';
import EditCaseDetails from './modules/cases/EditCaseDetails';
import BulkUpdateCashLogs from './modules/cashLogs/BulkUpdateCashLogs';
import CashLogCustomNote from './modules/cashLogs/CashLogCustomNote';
import CreateManualClear from './modules/cashLogs/CreateManualClear';
import InvalidateCashLog from './modules/cashLogs/InvalidateCashLog';
import CreateCashService from './modules/cashServices/CreateCashService';
import EditCashService from './modules/cashServices/EditCashService';
import CreateCashVaultBranch from './modules/cashVaultBranches/CreateCashVaultBranch';
import EditCashVaultBranch from './modules/cashVaultBranches/EditCashVaultBranch';
import ActionNote from './modules/customers/ActionNote';
import CustomNote from './modules/customers/CustomNote';
import LinkAccount from './modules/customers/LinkAccount';
import RemoveMatch from './modules/customers/RemoveMatch';
import UnlinkAccount from './modules/customers/UnlinkAccount';
import UploadDocument from './modules/customers/UploadDocument';
import IssueDetails from './modules/issues/IssueDetails';
import CreateLocation from './modules/locations/CreateLocation';
import DeleteLocation from './modules/locations/DeleteLocation';
import EditLocation from './modules/locations/EditLocation';
import EditLocationPrompt from './modules/locations/EditLocationPrompt';
import InstallMachine from './modules/locations/InstallMachine';
import LocationCustomNote from './modules/locations/LocationCustomNote';
import LocationEditNote from './modules/locations/LocationEditNote';
import PublishLocation from './modules/locations/PublishLocation';
import RemoveMachine from './modules/locations/RemoveMachine';
import RemoveMachines from './modules/locations/RemoveMachines';
import UnpublishLocation from './modules/locations/UnpublishLocation';
import ChangeMachineLocation from './modules/machine/ChangeMachineLocation';
import ClearCashboxMachine from './modules/machine/ClearCashboxMachine';
import EditMachine from './modules/machine/EditMachine';
import EditMachineLocksModem from './modules/machine/EditMachineLocksModem';
import RestartMachine from './modules/machine/RestartMachine';
import StatusMachine from './modules/machine/StatusMachine';
import TestDispenseMachine from './modules/machine/TestDispenseMachine';
import BulkAssociateTags from './modules/machines/BulkAssociateTags';
import BulkClearCashboxMachine from './modules/machines/BulkClearCashboxMachine';
import BulkRestartMachines from './modules/machines/BulkRestartMachines';
import BulkSetMachineStatus from './modules/machines/BulkSetMachineStatus';
import BulkToggleCoins from './modules/machines/BulkToggleCoins';
import BulkUnassociateTags from './modules/machines/BulkUnassociateTags';
import ApproveQueueItem from './modules/marketing/ApproveQueueItem';
import BulkApproveQueue from './modules/marketing/BulkApproveQueue';
import BulkMarketingListingAction from './modules/marketing/BulkMarketingListingAction';
import BulkMarketingListingReview from './modules/marketing/BulkMarketingListingReview';
import BulkRejectQueue from './modules/marketing/BulkRejectQueue';
import CreateCoupon from './modules/marketing/CreateCoupon';
import EditCoupon from './modules/marketing/EditCoupon';
import PublishMarketingListing from './modules/marketing/PublishMarketingListing';
import QueueItemDetail from './modules/marketing/QueueItemDetail';
import RejectQueueItem from './modules/marketing/RejectQueueItem';
import UnpublishMarketingListing from './modules/marketing/UnpublishMarketingListing';
import BulkAssignMerchant from './modules/merchants/BulkAssignMerchant';
import CreateMerchant from './modules/merchants/CreateMerchant';
import MerchantEditDetails from './modules/merchants/MerchantEditDetails';
import Notifications from './modules/notifications/Notifications';
import NotificationsDetail from './modules/notifications/NotificationsDetail';
import NotificationsSettings from './modules/notifications/NotificationsSettings';
import CreateOpsService from './modules/opsServices/CreateOpsService';
import EditOpsService from './modules/opsServices/EditOpsService';
import CreateResolutionReason from './modules/resolutionReasons/CreateResolutionReason';
import EditResolutionReason from './modules/resolutionReasons/EditResolutionReason';
import CancelLoadOrder from './modules/restocking/CancelLoadOrder';
import CreateLoadOrderAdjustment from './modules/restocking/CreateLoadOrderAdjustment';
import CreateReconciliation from './modules/restocking/CreateReconciliation';
import EditInventoryThreshold from './modules/restocking/EditInventoryThreshold';
import EditLoadOrder from './modules/restocking/EditLoadOrder';
import FulfillLoadOrder from './modules/restocking/FulfillLoadOrder';
import ManageRouteServiceTickets from './modules/routes/ManageRouteServiceTickets';
import RouteEdit from './modules/routes/RouteEdit';
import AssignRouteServiceTicket from './modules/serviceTickets/AssignRouteServiceTicket';
import AssignTechnicianServiceTicket from './modules/serviceTickets/AssignTechnicianServiceTicket';
import CloseServiceTicket from './modules/serviceTickets/CloseServiceTicket';
import CreateServiceTicket from './modules/serviceTickets/CreateServiceTicket';
import ManageServiceTicketTask from './modules/serviceTickets/ManageServiceTicketTask';
import ResolveServiceTicketTask from './modules/serviceTickets/ResolveServiceTicketTask';
import ServiceTicketCustomNote from './modules/serviceTickets/ServiceTicketCustomNote';
import ServiceTicketNoteUploadAttachment from './modules/serviceTickets/ServiceTicketNoteUploadAttachment';
import UpdateServiceTicketStatus from './modules/serviceTickets/UpdateServiceTicketStatus';
import DeleteTag from './modules/tag/DeleteTag';
import CreateTaskType from './modules/taskTypes/CreateTaskType';
import EditTaskType from './modules/taskTypes/EditTaskType';
import FreezeTransaction from './modules/transaction/FreezeTransaction';
import RefundTransaction from './modules/transaction/RefundTransaction';
import TransactionDetails from './modules/transaction/TransactionDetails';
import UnfreezeTransaction from './modules/transaction/UnfreezeTransaction';
import CreateUser from './modules/users/CreateUser';
import CreateUserV2 from './modules/users/CreateUserV2';
import UserEditRole from './modules/users/EditRole';
import UserEditRoleV2 from './modules/users/EditRoleV2';
import UserResetPasswordV2 from './modules/users/ResetPasswordV2';
import BitgoSettings from './modules/wallet/BitgoSettings';
import GenerateAddressesv1 from './modules/wallet/GenerateAddresses';
import QrCode from './modules/wallets/QrCode';

const MODALS: Modals[] = [
  {
    id: 'tag-delete',
    title: 'Delete Tag',
    component: DeleteTag,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576 },
    },
  },
  {
    id: 'qr-code',
    title: 'Deposit Address',
    component: QrCode,
    size: 'sm',
  },
  {
    id: 'wallet-generate-addresses',
    title: 'Generate New Addresses',
    component: GenerateAddressesv1,
    size: 'sm',
  },
  {
    id: 'machine-restart',
    title: 'Restart Machine',
    component: RestartMachine,
    size: 'sm',
  },
  {
    id: 'machines-bulk-restart',
    title: 'Restart Machines',
    component: BulkRestartMachines,
    size: 'sm',
  },
  {
    id: 'machine-status',
    title: 'Change Machine Status',
    component: StatusMachine,
    size: 'sm',
  },
  {
    id: 'machines-bulk-set-status',
    title: 'Set Machine Status',
    component: BulkSetMachineStatus,
  },
  {
    id: 'machine-edit',
    title: 'Edit Machine Details',
    component: EditMachine,
    anchor: 'right',
    type: 'drawer',
    PaperProps: {
      sx: { maxWidth: 600, width: '100%' },
    },
  },
  {
    id: 'machine-edit-locks-modem',
    title: 'Edit Lock/Modem Details',
    component: EditMachineLocksModem,
    size: 'sm',
  },
  {
    id: 'machine-location',
    title: 'Install at Location',
    component: ChangeMachineLocation,
    size: 'sm',
  },
  {
    id: 'location-create',
    title: 'New Location',
    component: CreateLocation,
    anchor: 'right',
    type: 'drawer',
    PaperProps: {
      sx: { maxWidth: 600, width: '100%' },
    },
  },
  {
    id: 'machine-clear-cashbox',
    title: 'Clear Cashbox',
    component: ClearCashboxMachine,
    size: 'sm',
  },
  {
    id: 'machine-test-dispense',
    title: 'Test Dispense',
    component: TestDispenseMachine,
    size: 'sm',
  },
  {
    id: 'machines-bulk-clear-cashbox',
    title: 'Clear Cashbox',
    component: BulkClearCashboxMachine,
    size: 'sm',
  },
  {
    id: 'transaction-details',
    title: 'Sale Details',
    component: TransactionDetails,
    anchor: 'right',
    type: 'drawer',
    PaperProps: { sx: { maxWidth: 552 } },
  },
  {
    id: 'customer-action-note',
    title: 'Customer Note',
    component: ActionNote,
    size: 'sm',
  },
  {
    id: 'custom-note',
    title: 'Custom Note',
    component: CustomNote,
    size: 'sm',
  },
  {
    id: 'edit-inventory-threshold',
    title: 'Low Cassette Threshold',
    component: EditInventoryThreshold,
    size: 'sm',
  },
  {
    id: 'fulfill-load-order',
    title: 'Fulfill Load Order',
    component: FulfillLoadOrder,
    size: 'sm',
  },
  {
    id: 'cancel-load-order',
    title: 'Cancel Load Order',
    component: CancelLoadOrder,
    size: 'sm',
  },
  {
    id: 'edit-load-order',
    title: 'Edit Load Order',
    component: EditLoadOrder,
    anchor: 'right',
    type: 'drawer',
    PaperProps: { sx: { maxWidth: 640, width: { md: 640 } } },
  },
  {
    id: 'create-load-order-adjustment',
    title: 'Make Adjustment',
    component: CreateLoadOrderAdjustment,
    anchor: 'right',
    type: 'drawer',
    PaperProps: { sx: { maxWidth: 640, width: { md: 640 } } },
  },
  {
    id: 'create-reconciliation',
    title: 'Create Reconciliation',
    component: CreateReconciliation,
    anchor: 'right',
    type: 'drawer',
    PaperProps: { sx: { maxWidth: 640, width: { md: 640 } } },
  },
  {
    id: 'location-custom-note',
    title: 'Custom Note',
    component: LocationCustomNote,
    size: 'sm',
  },
  {
    id: 'location-edit-note',
    title: 'Edit Note',
    component: LocationEditNote,
    size: 'sm',
  },
  {
    id: 'upload-document',
    title: 'Upload document',
    component: UploadDocument,
    size: 'sm',
  },
  {
    id: 'connect-vendor',
    title: 'Connect new vendor',
    component: ConnectVendor,
    size: 'sm',
  },
  {
    id: 'activate-vendor',
    title: 'Activate Vendor',
    component: ActivateVendor,
    size: 'sm',
  },
  {
    id: 'edit-vendor',
    title: 'Edit Vendor',
    component: EditVendor,
    size: 'sm',
  },
  {
    id: 'notifications',
    title: 'Notifications',
    component: Notifications,
    anchor: 'right',
    type: 'drawer',
    PaperProps: {
      sx: { maxWidth: 552, width: '100%' },
    },
  },
  {
    id: 'notifications-settings',
    title: 'Notifications',
    component: NotificationsSettings,
    anchor: 'right',
    type: 'drawer',
    PaperProps: {
      sx: { maxWidth: 552, width: '100%' },
    },
  },
  {
    id: 'notifications-detail',
    title: 'Notifications',
    component: NotificationsDetail,
    anchor: 'right',
    type: 'drawer',
    PaperProps: {
      sx: { maxWidth: 552, width: '100%' },
    },
  },
  {
    id: 'customer-link-account',
    title: 'Link Account',
    component: LinkAccount,
    anchor: 'right',
    type: 'drawer',
    PaperProps: {
      sx: { maxWidth: 586, width: '100%' },
    },
  },
  {
    id: 'customer-unlink-account',
    title: 'Unlink Account',
    component: UnlinkAccount,
    size: 'md',
    PaperProps: {
      sx: { maxWidth: 720 },
    },
  },
  {
    id: 'customer-remove-match',
    title: 'Remove Match',
    component: RemoveMatch,
    size: 'sm',
  },
  {
    id: 'batching-settings',
    title: 'Batching settings',
    component: BatchingSettings,
    size: 'sm',
  },
  {
    id: 'batching-details',
    title: 'Batching details',
    component: BatchDetails,
    size: 'xl',
  },
  {
    id: 'bulk-associate-tags',
    title: 'Add Tag',
    component: BulkAssociateTags,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576, width: '100%' },
    },
  },
  {
    id: 'bulk-unassociate-tags',
    title: 'Remove Tag',
    component: BulkUnassociateTags,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576, width: '100%' },
    },
  },
  {
    id: 'machines-bulk-toggle-coins',
    component: BulkToggleCoins,
    size: 'md',
    PaperProps: {
      sx: { width: '100%' },
    },
  },
  {
    id: 'wallet-bitgo-settings',
    title: 'Bitgo Settings',
    component: BitgoSettings,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576, width: '100%' },
    },
  },
  {
    id: 'user-edit-role',
    title: 'Edit Role',
    component: UserEditRole,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576, width: '100%' },
    },
  },
  {
    id: 'user-create',
    title: 'Create User',
    component: CreateUser,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576, width: '100%' },
    },
  },
  {
    id: 'user-edit-role-v2',
    title: 'Edit Role',
    component: UserEditRoleV2,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576, width: '100%' },
    },
  },
  {
    id: 'user-create-v2',
    title: 'Create User',
    component: CreateUserV2,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576, width: '100%' },
    },
  },
  {
    id: 'user-reset-password-v2',
    title: 'Reset Password',
    component: UserResetPasswordV2,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576, width: '100%' },
    },
  },
  {
    id: 'affiliate-create',
    title: 'Create Affiliate',
    component: CreateAffiliate,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576, width: '100%' },
    },
  },
  {
    id: 'affiliate-add-user',
    title: 'Add Affiliate User',
    component: AffiliateAddUser,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576, width: '100%' },
    },
  },
  {
    id: 'affiliate-create-v2',
    title: 'Create Affiliate',
    component: CreateAffiliateV2,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576, width: '100%' },
    },
  },
  {
    id: 'affiliate-add-user-v2',
    title: 'Add Affiliate User',
    component: AffiliateAddUserV2,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576, width: '100%' },
    },
  },
  {
    id: 'affiliate-add-machines',
    title: 'Add Machines',
    component: AffiliateAddMachines,
    size: 'lg',
  },
  {
    id: 'location-edit',
    title: 'Edit Location Details',
    component: EditLocation,
    anchor: 'right',
    type: 'drawer',
    PaperProps: {
      sx: { maxWidth: 600, width: '100%' },
    },
  },
  {
    id: 'location-publish',
    title: 'Publish Location',
    component: PublishLocation,
    size: 'sm',
  },
  {
    id: 'location-edit-prompt',
    title: 'Edit Location Details',
    component: EditLocationPrompt,
    size: 'sm',
  },
  {
    id: 'location-delete',
    title: 'Delete Location',
    component: DeleteLocation,
    PaperProps: {
      sx: { maxWidth: 600, width: '100%' },
    },
  },
  {
    id: 'location-unpublish',
    title: 'Unpublish Location',
    component: UnpublishLocation,
    size: 'sm',
  },
  {
    id: 'location-install-machine',
    title: 'Install Machine',
    component: InstallMachine,
    size: 'md',
  },
  {
    id: 'location-remove-machines',
    title: 'Remove Machines',
    component: RemoveMachines,
    size: 'sm',
  },
  {
    id: 'location-remove-machine',
    title: 'Remove Machine',
    component: RemoveMachine,
    size: 'sm',
  },
  {
    id: 'merchant-create',
    title: 'Create Merchant',
    component: CreateMerchant,
    size: 'sm',
  },
  {
    id: 'create-task-type',
    title: 'Create Task Type',
    component: CreateTaskType,
    size: 'sm',
  },
  {
    id: 'edit-task-type',
    title: 'Edit Task Type',
    component: EditTaskType,
    size: 'sm',
  },
  {
    id: 'create-ops-service',
    title: 'Create Ops Service',
    component: CreateOpsService,
    size: 'sm',
  },
  {
    id: 'edit-ops-service',
    title: 'Edit Ops Service',
    component: EditOpsService,
    size: 'sm',
  },
  {
    id: 'create-cash-service',
    title: 'Create Cash Service',
    component: CreateCashService,
    size: 'sm',
  },
  {
    id: 'edit-cash-service',
    title: 'Edit Cash Service',
    component: EditCashService,
    size: 'sm',
  },
  {
    id: 'create-cash-vault-branch',
    title: 'Create Cash Vault Branch',
    component: CreateCashVaultBranch,
    size: 'sm',
  },
  {
    id: 'edit-cash-vault-branch',
    title: 'Edit Cash Vault Branch',
    component: EditCashVaultBranch,
    size: 'sm',
  },
  {
    id: 'create-resolution-reason',
    title: 'Create Resolution Reason',
    component: CreateResolutionReason,
    size: 'sm',
  },
  {
    id: 'edit-resolution-reason',
    title: 'Edit Resolution Reason',
    component: EditResolutionReason,
    size: 'sm',
  },
  {
    id: 'merchant-edit-details',
    title: 'Edit Merchant details',
    component: MerchantEditDetails,
    anchor: 'right',
    type: 'drawer',
    PaperProps: {
      sx: { maxWidth: 600, width: '100%' },
    },
  },
  {
    id: 'bulk-assign-merchant',
    title: 'Bulk Assign Merchant',
    component: BulkAssignMerchant,
    size: 'md',
    PaperProps: {
      sx: { maxWidth: 600, width: '100%' },
    },
  },
  {
    id: 'unfreeze-transaction',
    title: 'Unfreeze Transaction',
    component: UnfreezeTransaction,
    size: 'sm',
  },
  {
    id: 'refund-transaction',
    title: 'Refund Transaction',
    component: RefundTransaction,
    size: 'sm',
  },
  {
    id: 'freeze-transaction',
    title: 'Freeze Transaction',
    component: FreezeTransaction,
    size: 'sm',
  },
  {
    id: 'issue-details',
    title: 'Issue Details',
    component: IssueDetails,
    anchor: 'right',
    type: 'drawer',
    PaperProps: {
      sx: { maxWidth: 600, width: '100%' },
    },
  },
  {
    id: 'case-close',
    title: 'Close Case',
    component: CaseCloseModal,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576, width: '100%' },
    },
  },
  {
    id: 'case-custom-note',
    title: 'Add Case Note',
    component: CaseCustomNote,
    size: 'sm',
  },
  {
    id: 'case-note-upload-attachment',
    title: 'Upload Attachment',
    component: CaseNoteUploadAttachment,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 500, width: '100%' },
    },
  },
  {
    id: 'case-edit-details',
    title: 'Edit Case Details',
    component: EditCaseDetails,
    anchor: 'right',
    type: 'drawer',
    PaperProps: {
      sx: { maxWidth: 500, width: '100%' },
    },
  },
  {
    id: 'case-restart-command',
    title: 'Send Restart Command',
    component: CaseRestartCommand,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576 },
    },
  },
  {
    id: 'service-ticket-create',
    title: 'Create Service Ticket',
    component: CreateServiceTicket,
    anchor: 'right',
    type: 'drawer',
    PaperProps: {
      sx: { maxWidth: 600, width: '100%' },
    },
  },
  {
    id: 'assign-technician-service-ticket',
    title: 'Assign Technician to Service Ticket',
    component: AssignTechnicianServiceTicket,
    size: 'sm',
  },
  {
    id: 'assign-route-service-ticket',
    title: 'Assign Route to Service Ticket',
    component: AssignRouteServiceTicket,
    size: 'sm',
  },
  {
    id: 'service-ticket-custom-note',
    title: 'Add Note to Service Ticket',
    component: ServiceTicketCustomNote,
    size: 'sm',
  },
  {
    id: 'service-ticket-note-upload-attachment',
    title: 'Upload Attachment',
    component: ServiceTicketNoteUploadAttachment,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 500, width: '100%' },
    },
  },
  {
    id: 'close-service-ticket',
    title: 'Close Service Ticket',
    component: CloseServiceTicket,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576, width: '100%' },
    },
  },
  {
    id: 'update-service-ticket-status',
    title: 'Update Service Ticket Status',
    component: UpdateServiceTicketStatus,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576, width: '100%' },
    },
  },
  {
    id: 'service-ticket-task-add',
    title: 'Add Task',
    component: ManageServiceTicketTask,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576, width: '100%' },
    },
  },
  {
    id: 'service-ticket-task-edit',
    title: 'Edit Task',
    component: ManageServiceTicketTask,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576, width: '100%' },
    },
  },
  {
    id: 'service-ticket-task-resolve',
    title: 'Resolve Task',
    component: ResolveServiceTicketTask,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 576, width: '100%' },
    },
  },
  {
    id: 'route-edit',
    title: 'Edit Route',
    component: RouteEdit,
    size: 'sm',
    PaperProps: {
      sx: { maxWidth: 600, width: '100%' },
    },
  },
  {
    id: 'manage-route-service-tickets',
    title: 'Manage Service Tickets',
    component: ManageRouteServiceTickets,
    size: 'lg',
    PaperProps: {
      sx: { maxWidth: 1200, width: '100%' },
    },
  },

  // Marketing — Bulk listing actions
  {
    id: 'marketing-listing-bulk-action',
    title: 'Bulk Listing Action',
    component: BulkMarketingListingAction,
    size: 'md',
  },
  {
    id: 'marketing-listing-bulk-review',
    title: 'Bulk Review Action',
    component: BulkMarketingListingReview,
    size: 'md',
  },

  // Marketing — Listing actions
  {
    id: 'marketing-listing-publish',
    title: 'Publish Listing',
    component: PublishMarketingListing,
    size: 'sm',
  },
  {
    id: 'marketing-listing-unpublish',
    title: 'Unpublish Listing',
    component: UnpublishMarketingListing,
    size: 'sm',
  },

  // Marketing — Coupons
  {
    id: 'coupon-create',
    title: 'Create Coupon',
    component: CreateCoupon,
    anchor: 'right',
    type: 'drawer',
    PaperProps: { sx: { maxWidth: 600, width: '100%' } },
  },
  {
    id: 'coupon-edit',
    title: 'Edit Coupon',
    component: EditCoupon,
    anchor: 'right',
    type: 'drawer',
    PaperProps: { sx: { maxWidth: 600, width: '100%' } },
  },

  // Marketing — Queue modals
  {
    id: 'queue-item-approve',
    title: 'Publish Queue Item',
    component: ApproveQueueItem,
    size: 'sm',
  },
  { id: 'queue-item-reject', title: 'Reject Queue Item', component: RejectQueueItem, size: 'sm' },
  {
    id: 'queue-bulk-approve',
    title: 'Publish Queue Items',
    component: BulkApproveQueue,
    size: 'sm',
  },
  { id: 'queue-bulk-reject', title: 'Reject Queue Items', component: BulkRejectQueue, size: 'sm' },

  // Cash logs
  {
    id: 'cash-log-invalidate',
    title: 'Invalidate Cash Log',
    component: InvalidateCashLog,
    size: 'lg',
    PaperProps: { sx: { maxWidth: 900, width: '100%' } },
  },
  {
    id: 'cash-log-create-manual',
    title: 'Create Manual Clear',
    component: CreateManualClear,
    size: 'md',
    PaperProps: { sx: { maxWidth: 720, width: '100%' } },
  },
  {
    id: 'cash-log-custom-note',
    title: 'Add Note to Cash Clear',
    component: CashLogCustomNote,
    size: 'sm',
  },
  {
    id: 'cash-log-bulk-confirm',
    title: 'Confirm Cash Clears',
    component: BulkUpdateCashLogs,
    size: 'md',
    PaperProps: { sx: { maxWidth: 720, width: '100%' } },
  },
  {
    id: 'cash-log-bulk-set-provisional',
    title: 'Set Cash Clears to Provisional',
    component: BulkUpdateCashLogs,
    size: 'md',
    PaperProps: { sx: { maxWidth: 720, width: '100%' } },
  },
  {
    id: 'cash-log-bulk-set-deposited',
    title: 'Set Cash Clears to Deposited',
    component: BulkUpdateCashLogs,
    size: 'md',
    PaperProps: { sx: { maxWidth: 720, width: '100%' } },
  },
  {
    id: 'cash-log-bulk-set-deposited-over',
    title: 'Set Cash Clears to Deposited Over',
    component: BulkUpdateCashLogs,
    size: 'md',
    PaperProps: { sx: { maxWidth: 720, width: '100%' } },
  },
  {
    id: 'cash-log-bulk-set-deposited-under',
    title: 'Set Cash Clears to Deposited Under',
    component: BulkUpdateCashLogs,
    size: 'md',
    PaperProps: { sx: { maxWidth: 720, width: '100%' } },
  },
  {
    id: 'cash-log-bulk-set-voided',
    title: 'Set Cash Clears to Voided',
    component: BulkUpdateCashLogs,
    size: 'md',
    PaperProps: { sx: { maxWidth: 720, width: '100%' } },
  },
  {
    id: 'queue-item-detail',
    title: 'Queue Item Details',
    component: QueueItemDetail,
    anchor: 'right',
    type: 'drawer',
    PaperProps: { sx: { maxWidth: 600, width: '100%' } },
  },
];

const ModalProviderWrapper = ({ children }: { children: React.ReactNode }) => (
  <ModalProvider modals={MODALS}>
    <>{children}</>
  </ModalProvider>
);

export default ModalProviderWrapper;
